<template>
  <div id="app">
    <div id="preload">
      <img src="./assets/imgs/home.jpg" />
      <img src="./assets/imgs/comentario_ceo.jpg" />
      <img src="./assets/imgs/arrecadacao.jpg" />
      <img src="./assets/imgs/distribuicao.jpg" />
      <img src="./assets/imgs/diretordeoperacoes.jpg" />
      <img src="./assets/imgs/numeros2024.jpg" />
      <img src="./assets/imgs/principais_atividades.jpg" />
    </div>
    <div class="menu" v-bind:class="{ isOpen: hamburguerState }">
      <nav>
        <ul>
          <li>
            <router-link to="/"
              ><span v-on:click="checkHamburguer()">Intro</span></router-link
            >
          </li>
          <li>
            <router-link to="/PalavrasDiretorExecutivo"
              ><span v-on:click="checkHamburguer(), checkIsTransition()"
                >Algumas palavras do nosso diretor-executivo</span
              ></router-link
            >
          </li>
          <li>
            <router-link to="/Arrecadacao"
              ><span v-on:click="checkHamburguer(), checkIsTransition()"
                >Arrecadação</span
              ></router-link
            >
          </li>
          <li>
            <router-link to="/Distribuicao"
              ><span v-on:click="checkHamburguer(), checkIsTransition()"
                >Distribuição</span
              ></router-link
            >
          </li>
          <li>
            <router-link to="/AnaliseDiretorDeOperacoes"
              ><span v-on:click="checkHamburguer(), checkIsTransition()"
                >Uma análise do nosso diretor de operações</span
              ></router-link
            >
          </li>
          <li>
            <router-link to="/OsNumeros2025"
              ><span v-on:click="checkHamburguer(), checkIsTransition()"
                >Os números da UBC em 2025</span
              ></router-link
            >
          </li>
          <li>
            <router-link to="/AtividadesPrincipais"
              ><span v-on:click="checkHamburguer(), checkIsTransition()"
                >Atividades Principais</span
              ></router-link
            >
          </li>
        </ul>
      </nav>
    </div>
    <!-- menu -->
    <div class="abertura" :class="setBackground"></div>
    <div class="magic">
      <div
        class="canto"
        :class="{
          conteudoIntPart1: isInternal,
          conteudoCantoIntTrans: isTransition,
        }"
      >
        <div class="cantoBranco"></div>
        <div class="cantoCurva">
          <img src="./assets/imgs/curvacanto.png" />
        </div>
      </div>
      <!-- canto -->
      <div
        class="conteudo"
        :class="{
          conteudoIntPart2: isInternal,
          conteudoIntTrans: isTransition,
        }"
      >
        <transition name="testao">
          <router-view
            v-on:go-next="goNext"
            v-on:go-back="goBack"
          ></router-view>
        </transition>
      </div>
      <!-- conteudo -->
      <div
        class="ubc"
        :class="{
          conteudoIntPart3: isInternal,
          ubcIntTrans: isTransition,
        }"
      >
        <div
          class="botaoIniciar btHome"
          :class="{ botaoIniciarOff: isInternal }"
        >
          <router-link class="boxInicio" to="/PalavrasDiretorExecutivo">
            <span class="move"><i class="right"></i></span>
          </router-link>
        </div>
        <div class="ubcImg">
          <img src="./assets/imgs/ubcpart.png" />
        </div>
      </div>
      <!-- ubc -->

      <div
        class="botaoIniciar btHomeMob"
        :class="{ botaoIniciarOff: isInternal }"
      >
        <router-link class="boxInicio" to="/PalavrasDiretorExecutivo">
          <span class="move"><i class="right"></i></span>
        </router-link>
      </div>

      <transition name="fadeMenuHorizontal">
        <div v-if="menuHorizontal" class="menuBar">
          <div class="homeBarHorizontal">
            <div class="titulo"><h1>Relatório anual 2025</h1></div>
            <div class="boxDirHor">
              <div class="idioma">
                <div class="active-idiom">PORT</div>
                <a
                  href="https://hotsite.ubc.org.br/Hotsite/Relatorio_Anual/2025/esp"
                  ><div>ESP</div></a
                >
                <a
                  href="https://hotsite.ubc.org.br/Hotsite/Relatorio_Anual/2025/eng"
                  ><div>ENG</div></a
                >
              </div>
              <div class="equaliser-container" v-on:click="checkMusicState">
                <div :class="{ icoMusicState: musicState }" class="icoMusic">
                  &#9835;
                </div>
                <ol class="equaliser-column">
                  <li
                    class="staticSoundBar"
                    :class="{ colourBar: musicState }"
                  ></li>
                </ol>
                <ol class="equaliser-column">
                  <li
                    class="staticSoundBar"
                    :class="{ colourBar: musicState }"
                  ></li>
                </ol>
                <ol class="equaliser-column">
                  <li
                    class="staticSoundBar"
                    :class="{ colourBar: musicState }"
                  ></li>
                </ol>
                <ol class="equaliser-column">
                  <li
                    class="staticSoundBar"
                    :class="{ colourBar: musicState }"
                  ></li>
                </ol>
                <ol class="equaliser-column">
                  <li
                    class="staticSoundBar"
                    :class="{ colourBar: musicState }"
                  ></li>
                </ol>
              </div>
            </div>
          </div>
          <!-- homeBarHorizontal -->
        </div>
        <!-- menuBar -->
      </transition>

      <div class="hamburguerdiv">
        <button
          class="hamburger hamburger--collapse"
          v-on:click="checkHamburguer"
          type="button"
          v-bind:class="{ isActive: hamburguerState }"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>

      <div class="tituloCelVert"><h1>Relatório anual 2025</h1></div>

      <transition name="fadeMenuVertical">
        <div v-if="menuVertical" class="menuBarVertical">
          <div
            class="equaliser-container"
            v-on:click="checkMusicState"
            style="margin: 70px 0 0 0 !important; align-self: center"
          >
            <div :class="{ icoMusicState: musicState }" class="icoMusic">
              &#9835;
            </div>
            <ol class="equaliser-column">
              <li
                class="staticSoundBar"
                :class="{ colourBar: musicState }"
              ></li>
            </ol>
            <ol class="equaliser-column">
              <li
                class="staticSoundBar"
                :class="{ colourBar: musicState }"
              ></li>
            </ol>
            <ol class="equaliser-column">
              <li
                class="staticSoundBar"
                :class="{ colourBar: musicState }"
              ></li>
            </ol>
            <ol class="equaliser-column">
              <li
                class="staticSoundBar"
                :class="{ colourBar: musicState }"
              ></li>
            </ol>
            <ol class="equaliser-column">
              <li
                class="staticSoundBar"
                :class="{ colourBar: musicState }"
              ></li>
            </ol>
          </div>
          <div class="titulo"><h1>Relatório anual 2025</h1></div>
        </div>
        <!-- menuBarVertical -->
      </transition>
    </div>
    <!-- magic -->
    <audio id="myAudio" ref="music">
      <source src="./assets/audio/music.mp3" type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
  </div>
  <!-- app -->
</template>

<script>
export default {
  name: "App",

  data() {
    return {
      isInternal: false,
      menuHorizontal: true,
      menuVertical: false,
      hamburguerState: false,
      isTransition: false,
      clicked: false,
      musicState: false,
      setBackground: [],
    };
  },
  created() {
    this.checkPath();
    // let lastKeyTime = Date.now();
    document.onkeydown = this.onkeydown;
  },

  watch: {
    "$route.path": "checkPath",
  },

  methods: {
    playAudio: function () {
      this.$refs.music.play();
    },
    checkPath: function () {
      let route = this.$route.path;
      this.setBackground = route;
      let resultado = this.setBackground.replace("/", "back-");
      this.setBackground = resultado;

      if (route != "/") {
        (this.isInternal = true),
          (this.menuHorizontal = false),
          (this.menuVertical = true);
      } else {
        (this.isInternal = false),
          (this.menuHorizontal = true),
          (this.menuVertical = false);
      }
    },
    checkHamburguer: function () {
      this.hamburguerState = !this.hamburguerState;
    },
    checkMusicState: function () {
      this.musicState = !this.musicState;
      if (this.$refs.music.paused) {
        this.$refs.music.play();
      } else {
        this.$refs.music.pause();
      }
    },
    checkIsTransition: function () {
      let pathatual = this.$route.path;
      if (pathatual === "/") {
        // nada
      } else {
        this.isTransition = !this.isTransition;

        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      }
    },
    goNext: function () {
      this.clicked = true;
      setTimeout(
        function () {
          this.clicked = false;
        }.bind(this),
        1499,
      );
      let pathatual = this.$route.path;
      if (pathatual === "/PalavrasDiretorExecutivo") {
        this.$router.push("Arrecadacao");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (pathatual === "/Arrecadacao") {
        this.$router.push("Distribuicao");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (pathatual === "/Distribuicao") {
        this.$router.push("AnaliseDiretorDeOperacoes");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (pathatual === "/AnaliseDiretorDeOperacoes") {
        this.isTransition = !this.isTransition;
        this.$router.push("OsNumeros2025");
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (pathatual === "/OsNumeros2025") {
        this.isTransition = !this.isTransition;
        this.$router.push("AtividadesPrincipais");
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (pathatual === "/AtividadesPrincipais") {
        // final //
      }
    },
    goBack: function () {
      this.clicked = true;
      setTimeout(
        function () {
          this.clicked = false;
        }.bind(this),
        1499,
      );
      let pathatual = this.$route.path;
      if (pathatual === "/PalavrasDiretorExecutivo") {
        this.$router.push("/");
      } else if (pathatual === "/Arrecadacao") {
        this.$router.push("PalavrasDiretorExecutivo");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (pathatual === "/Distribuicao") {
        this.$router.push("Arrecadacao");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (pathatual === "/AnaliseDiretorDeOperacoes") {
        this.$router.push("Distribuicao");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (pathatual === "/OsNumeros2025") {
        this.$router.push("AnaliseDiretorDeOperacoes");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (pathatual === "/AtividadesPrincipais") {
        this.$router.push("OsNumeros2025");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      }
    },

    onkeydown: function (e) {
      let tecla = e.keyCode;
      let pathatual = this.$route.path;
      const currentTime = Date.now();

      if (
        tecla == 39 &&
        pathatual === "/" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        console.log("ds");
        this.$router.push("PalavrasDiretorExecutivo");
      } else if (tecla == 37 && pathatual === "/") {
        // nada
      } else if (
        tecla == 39 &&
        pathatual === "/PalavrasDiretorExecutivo" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("Arrecadacao");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (
        tecla == 37 &&
        pathatual === "/PalavrasDiretorExecutivo" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("/");
      } else if (
        tecla == 39 &&
        pathatual === "/Arrecadacao" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("Distribuicao");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (
        tecla == 37 &&
        pathatual === "/Arrecadacao" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("PalavrasDiretorExecutivo");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (
        tecla == 39 &&
        pathatual === "/Distribuicao" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("AnaliseDiretorDeOperacoes");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (
        tecla == 37 &&
        pathatual === "/Distribuicao" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("Arrecadacao");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (
        tecla == 39 &&
        pathatual === "/AnaliseDiretorDeOperacoes" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("OsNumeros2025");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (
        tecla == 37 &&
        pathatual === "/AnaliseDiretorDeOperacoes" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("Distribuicao");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (
        tecla == 39 &&
        pathatual === "/OsNumeros2025" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("AtividadesPrincipais");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (
        tecla == 37 &&
        pathatual === "/OsNumeros2025" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("AnaliseDiretorDeOperacoes");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      } else if (
        tecla == 39 &&
        pathatual === "/AtividadesPrincipais" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        // nada
      } else if (
        tecla == 37 &&
        pathatual === "/AtividadesPrincipais" &&
        currentTime - this.lastKeyTime > 1499
      ) {
        this.$router.push("OsNumeros2025");
        this.isTransition = !this.isTransition;
        let self = this;
        setTimeout(function () {
          self.isTransition = false;
        }, 1499);
      }
      this.lastKeyTime = currentTime;
    },
  },
};
</script>

<style></style>
